var $name="shell/registry/ModuleContext",$path="app/modules/shell/registry/ModuleContext.js",$this={$name,$path,};import Context from './Context';

export default class ModuleContext extends Context { }
